import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromPacksNotSavedChanges from './state/packs-not-saved-changes.reducer';
import { PacksNotSavedChangesFacade } from './state/packs-not-saved-changes.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromPacksNotSavedChanges.PACKS_NOT_SAVED_CHANGES_FEATURE_KEY,
      fromPacksNotSavedChanges.packsNotSavedChangesReducer
    ),
  ],
  providers: [PacksNotSavedChangesFacade],
})
export class PacksNotSavedChangesModule {}
